import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HttpService, MessageService, params,  LocalStorageService, MenuBreadCrumb } from 'brainloper-ui';
import { FormCompanyComponent } from './form-company/form-company.component';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { ModalCompanyComponent } from './modal-company/modal-company.component';
import { Company } from 'app/models2/administration/company';


@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss']
})
export class CompaniesComponent implements OnInit {


  private urlGetCompanias: string  = `${EndpointDictionary.Company.COMPANY_COMBO}`;
  private res: any = ""
  public companias: Array<Company>;
  public baseUrl: String = `${EndpointDictionary.Base._BASE_URL_V2}`

  public menuBreadCrumb:Array<MenuBreadCrumb> = [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
    name:"Compañias",
    current:true
  }]

  constructor(
    private http: HttpService, //Servicio HTTP de Eter
    private message: MessageService, //Servicio de mensaje emergente Eter
    public dialog: MatDialog,
    private router: Router,
    private storage : LocalStorageService
  ) {
    let rol: string = this.storage.get<string>("rol")
    if(rol != 'root'){
      sessionStorage.clear()
      this.storage.clear()
      this.router.navigate(['/'])
    }
  }

  async ngOnInit() {
    await this.getCompanies(true)
  }

  async getCompanies(flg: boolean){
    flg?this.message.openLoading('Cargando...', 'Obteniendo compañias.'):""
    let params: params[] = [
      {
        id: 'page',
        value: '0',
      },
      {
        id: 'per_page',
        value: '10',
      },
      {
        id: 'filter',
        value: '',
      },
    ];
    this.res = await this.http
      .getData(this.urlGetCompanias)
      .toPromise();
    if (this.res.code === 0) {

      this.message.closeLoading();
      flg?this.message.SuccessToast('Compañias obtenidas correctamente.'):"";
      this.companias =this.res.body;
    } else {
      this.message.closeLoading();
      this.message.ErrorToast('Error obteniendo compañias');
    }
  }

 async handleClick(compania) {
    let size: number = screen.width > 500 ? 80 : 95;
    const dialogRef = this.dialog.open(ModalCompanyComponent, {
      width: `${size}vh`,
      height: `${size}vh`,
      data: this.companias[compania],
    })
    .afterClosed().subscribe(async data => {
        this.companias = []
        await this.getCompanies(false)
    })
  }

  async newCompania() {
    let size: number = screen.width > 500 ? 80 : 90;
    let companyId: number = 0;
    const dialogRef = this.dialog.open(FormCompanyComponent, {
      width: screen.height < 420 ? `${size}vw` : `${size}vh`,
      height: `${size}vh`,
      data: companyId
    })
    .afterClosed().subscribe(async data =>{
      if(data){
        this.companias = []
        await this.getCompanies(false)
      }
    })
  }

  handleLogo(){
    this.companias.forEach(element => {
      element.logo = `${EndpointDictionary.Base.BASE_URL_V2}${element.logo}`
    });
  }

}
